// Trinkgeld (Seite /tip/:tripId und Karte in „Buchung verwalten“). Flache Schlüssel, wird in fieldMapping.js eingemischt.
const de = {
  tp_eyebrow: "Neu bei GoTransfer24",
  tp_title: "Danke sagen –",
  tp_accent: "mit Trinkgeld für Ihren Fahrer",
  tp_text_free: "Zufrieden mit Ihrer Fahrt? Geben Sie nach der Fahrt freiwillig Trinkgeld – einfach, sicher und ohne Bargeld. Es kommt vollständig bei Ihrem Fahrer an, GoTransfer24 behält davon nichts ein.",
  tp_text_fee: "Zufrieden mit Ihrer Fahrt? Geben Sie nach der Fahrt freiwillig Trinkgeld – einfach, sicher und ohne Bargeld. Es geht an Ihr Fahrtunternehmen und wird an Ihren Fahrer weitergegeben.",
  tp_step1_t: "Fahrt genießen",
  tp_step1_d: "Entspannt ankommen – wir kümmern uns um den Rest.",
  tp_step2_t: "Link in der Mail",
  tp_step2_d: "Nach der Fahrt finden Sie den Trinkgeld-Link in Ihrer Mail.",
  tp_step3_t: "Betrag wählen",
  tp_step3_d: "2, 5 oder 10 € – oder ein eigener Betrag. Bezahlt per Karte.",
  tp_badge_free: "0 % Abzug",
  tp_badge_safe: "Sicher per Karte",
  tp_badge_free2: "Freiwillig",
  tp_phone_title: "Trinkgeld geben",
  tp_phone_btn: "Trinkgeld geben",
  tp_phone_to: "für Ihren Fahrer",
  tips_card_open: "Offen",
  tips_card_paid: "Ausgezahlt",
  tips_pay_out: "Trinkgeld ausgezahlt",
  tips_pay_out_confirm: "{amount} Trinkgeld an {name} als ausgezahlt markieren?",
  tips_history: "Verlauf",
  tips_history_hide: "Verlauf ausblenden",
  tips_paid_out_on: "ausgezahlt am",
  tips_still_open: "noch offen",
  tips_pay_out_done: "✔ {amount} als ausgezahlt markiert.",
  tips_tab: "💝 Trinkgeld",
  tips_driver_month: "Diesen Monat",
  tips_driver_total: "Gesamt",
  tips_driver_open: "Noch offen",
  tips_driver_empty: "Noch kein Trinkgeld erhalten.",
  tips_driver_passed: "✓ vom Unternehmen weitergegeben",
  tips_driver_pending: "Wird vom Unternehmen an Sie weitergegeben",
  tips_driver_hint: "Kunden können nach der Fahrt freiwillig Trinkgeld geben. Es geht an Ihr Unternehmen und wird von dort an Sie weitergegeben.",
  tips_partner_title: "Trinkgeld",
  tips_partner_hint: "Kunden geben Trinkgeld für den Fahrer. Der Betrag liegt in Ihrem Wallet – bitte geben Sie ihn an den Fahrer weiter und markieren Sie ihn dann als weitergegeben.",
  tips_partner_open: "Noch weiterzugeben",
  tips_partner_passed: "Weitergegeben",
  tips_partner_mark: "Als weitergegeben markieren",
  tips_partner_unmark: "Markierung zurücknehmen",
  tips_partner_driver: "Fahrer",
  tips_trip_label: "Trinkgeld",
  tip_title: "Trinkgeld geben",
  tip_intro: "Zufrieden mit Ihrer Fahrt? Mit einem Trinkgeld sagen Sie Danke.",
  tip_for: "für",
  tip_goes: "Das Trinkgeld geht vollständig an das Fahrtunternehmen{company} und wird an Ihren Fahrer weitergegeben. Es ist freiwillig.",
  tip_choose: "Betrag wählen",
  tip_custom: "Anderer Betrag (€)",
  tip_pay: "Trinkgeld per Karte geben",
  tip_thanks: "Vielen Dank! Ihr Trinkgeld von {amount} ist angekommen.",
  tip_given: "Sie haben für diese Fahrt bereits {amount} gegeben.",
  tip_cancelled: "Zahlung abgebrochen – es wurde nichts abgebucht.",
  tip_invalid: "Dieser Link ist ungültig.",
  tip_na: "Für diese Fahrt ist kein Trinkgeld (mehr) möglich.",
  tip_na_expired: "Trinkgeld ist nur bis {days} Tage nach der Fahrt möglich.",
  tip_na_notdone: "Trinkgeld ist erst nach Abschluss der Fahrt möglich.",
  tip_loading: "Lädt …",
  tip_card_title: "Trinkgeld",
  tip_card_text: "Zufrieden mit Ihrem Fahrer? Sagen Sie Danke mit einem Trinkgeld.",
  tip_card_btn: "💝 Trinkgeld geben",
  tip_card_leg_out: "für die Hinfahrt",
  tip_card_leg_ret: "für die Rückfahrt",
};
const en = {
  tp_eyebrow: "New at GoTransfer24",
  tp_title: "Say thank you –",
  tp_accent: "with a tip for your driver",
  tp_text_free: "Happy with your ride? Leave a voluntary tip after your trip – easy, secure and cashless. It reaches your driver in full; GoTransfer24 keeps nothing.",
  tp_text_fee: "Happy with your ride? Leave a voluntary tip after your trip – easy, secure and cashless. It goes to your transport company and is passed on to your driver.",
  tp_step1_t: "Enjoy the ride",
  tp_step1_d: "Arrive relaxed – we take care of the rest.",
  tp_step2_t: "Link in your email",
  tp_step2_d: "After the ride you will find the tip link in your email.",
  tp_step3_t: "Choose an amount",
  tp_step3_d: "€2, €5 or €10 – or your own amount. Paid by card.",
  tp_badge_free: "0 % deducted",
  tp_badge_safe: "Secure by card",
  tp_badge_free2: "Voluntary",
  tp_phone_title: "Leave a tip",
  tp_phone_btn: "Leave a tip",
  tp_phone_to: "for your driver",
  tips_card_open: "Open",
  tips_card_paid: "Paid out",
  tips_pay_out: "Tips paid out",
  tips_pay_out_confirm: "Mark {amount} in tips as paid out to {name}?",
  tips_history: "History",
  tips_history_hide: "Hide history",
  tips_paid_out_on: "paid out on",
  tips_still_open: "still open",
  tips_pay_out_done: "✔ {amount} marked as paid out.",
  tips_tab: "💝 Tips",
  tips_driver_month: "This month",
  tips_driver_total: "Total",
  tips_driver_open: "Still open",
  tips_driver_empty: "No tips received yet.",
  tips_driver_passed: "✓ passed on by the company",
  tips_driver_pending: "Will be passed on to you by the company",
  tips_driver_hint: "Customers can leave a voluntary tip after the ride. It goes to your company, which passes it on to you.",
  tips_partner_title: "Tips",
  tips_partner_hint: "Customers tip the driver. The amount is in your wallet – please pass it on to the driver and then mark it as passed on.",
  tips_partner_open: "Still to pass on",
  tips_partner_passed: "Passed on",
  tips_partner_mark: "Mark as passed on",
  tips_partner_unmark: "Undo mark",
  tips_partner_driver: "Driver",
  tips_trip_label: "Tip",
  tip_title: "Leave a tip",
  tip_intro: "Happy with your ride? Say thank you with a tip.",
  tip_for: "for",
  tip_goes: "The tip goes entirely to the transport company{company} and is passed on to your driver. It is voluntary.",
  tip_choose: "Choose an amount",
  tip_custom: "Other amount (€)",
  tip_pay: "Tip by card",
  tip_thanks: "Thank you! Your tip of {amount} has been received.",
  tip_given: "You have already given {amount} for this ride.",
  tip_cancelled: "Payment cancelled – nothing was charged.",
  tip_invalid: "This link is not valid.",
  tip_na: "Tipping is no longer possible for this ride.",
  tip_na_expired: "Tipping is only possible up to {days} days after the ride.",
  tip_na_notdone: "Tipping is possible once the ride is completed.",
  tip_loading: "Loading …",
  tip_card_title: "Tip",
  tip_card_text: "Happy with your driver? Say thank you with a tip.",
  tip_card_btn: "💝 Leave a tip",
  tip_card_leg_out: "for the outbound ride",
  tip_card_leg_ret: "for the return ride",
};
const tr = {
  tp_eyebrow: "GoTransfer24'te yeni",
  tp_title: "Teşekkür edin –",
  tp_accent: "sürücünüze bahşişle",
  tp_text_free: "Yolculuktan memnun kaldınız mı? Yolculuktan sonra isteğe bağlı bahşiş verin – kolay, güvenli ve nakitsiz. Bahşiş tamamen sürücünüze ulaşır, GoTransfer24 hiçbir kesinti yapmaz.",
  tp_text_fee: "Yolculuktan memnun kaldınız mı? Yolculuktan sonra isteğe bağlı bahşiş verin – kolay, güvenli ve nakitsiz. Bahşiş taşımacılık şirketinize gider ve sürücünüze aktarılır.",
  tp_step1_t: "Yolculuğun keyfini çıkarın",
  tp_step1_d: "Rahatça varın – gerisini biz hallederiz.",
  tp_step2_t: "E-postadaki bağlantı",
  tp_step2_d: "Yolculuktan sonra bahşiş bağlantısını e-postanızda bulursunuz.",
  tp_step3_t: "Tutar seçin",
  tp_step3_d: "2, 5 veya 10 € – ya da kendi tutarınız. Kartla ödenir.",
  tp_badge_free: "%0 kesinti",
  tp_badge_safe: "Kartla güvenli",
  tp_badge_free2: "İsteğe bağlı",
  tp_phone_title: "Bahşiş ver",
  tp_phone_btn: "Bahşiş ver",
  tp_phone_to: "sürücünüz için",
  tips_card_open: "Açık",
  tips_card_paid: "Ödendi",
  tips_pay_out: "Bahşiş ödendi",
  tips_pay_out_confirm: "{name} için {amount} bahşiş ödendi olarak işaretlensin mi?",
  tips_history: "Geçmiş",
  tips_history_hide: "Geçmişi gizle",
  tips_paid_out_on: "ödeme tarihi",
  tips_still_open: "henüz açık",
  tips_pay_out_done: "✔ {amount} ödendi olarak işaretlendi.",
  tips_tab: "💝 Bahşiş",
  tips_driver_month: "Bu ay",
  tips_driver_total: "Toplam",
  tips_driver_open: "Henüz açık",
  tips_driver_empty: "Henüz bahşiş alınmadı.",
  tips_driver_passed: "✓ şirket tarafından aktarıldı",
  tips_driver_pending: "Şirket tarafından size aktarılacak",
  tips_driver_hint: "Müşteriler yolculuktan sonra isteğe bağlı bahşiş verebilir. Şirketinize gider ve oradan size aktarılır.",
  tips_partner_title: "Bahşiş",
  tips_partner_hint: "Müşteriler sürücüye bahşiş verir. Tutar cüzdanınızdadır – lütfen sürücüye aktarın ve aktarıldı olarak işaretleyin.",
  tips_partner_open: "Aktarılacak",
  tips_partner_passed: "Aktarıldı",
  tips_partner_mark: "Aktarıldı olarak işaretle",
  tips_partner_unmark: "İşareti geri al",
  tips_partner_driver: "Sürücü",
  tips_trip_label: "Bahşiş",
  tip_title: "Bahşiş ver",
  tip_intro: "Yolculuktan memnun kaldınız mı? Bahşişle teşekkür edin.",
  tip_for: "için",
  tip_goes: "Bahşiş tamamen taşımacılık şirketine{company} gider ve sürücünüze aktarılır. Gönüllüdür.",
  tip_choose: "Tutar seçin",
  tip_custom: "Başka tutar (€)",
  tip_pay: "Kartla bahşiş ver",
  tip_thanks: "Teşekkürler! {amount} tutarındaki bahşişiniz ulaştı.",
  tip_given: "Bu yolculuk için zaten {amount} verdiniz.",
  tip_cancelled: "Ödeme iptal edildi – hiçbir tutar çekilmedi.",
  tip_invalid: "Bu bağlantı geçersiz.",
  tip_na: "Bu yolculuk için artık bahşiş verilemez.",
  tip_na_expired: "Bahşiş yalnızca yolculuktan sonraki {days} güne kadar verilebilir.",
  tip_na_notdone: "Bahşiş, yolculuk tamamlandıktan sonra verilebilir.",
  tip_loading: "Yükleniyor …",
  tip_card_title: "Bahşiş",
  tip_card_text: "Sürücünüzden memnun kaldınız mı? Bahşişle teşekkür edin.",
  tip_card_btn: "💝 Bahşiş ver",
  tip_card_leg_out: "gidiş için",
  tip_card_leg_ret: "dönüş için",
};
const pl = {
  tp_eyebrow: "Nowość w GoTransfer24",
  tp_title: "Podziękuj –",
  tp_accent: "napiwkiem dla kierowcy",
  tp_text_free: "Zadowolony z przejazdu? Zostaw dobrowolny napiwek po podróży – prosto, bezpiecznie i bezgotówkowo. Trafia w całości do kierowcy, GoTransfer24 nic nie potrąca.",
  tp_text_fee: "Zadowolony z przejazdu? Zostaw dobrowolny napiwek po podróży – prosto, bezpiecznie i bezgotówkowo. Trafia do firmy transportowej i jest przekazywany kierowcy.",
  tp_step1_t: "Ciesz się podróżą",
  tp_step1_d: "Dotrzyj zrelaksowany – resztą zajmiemy się my.",
  tp_step2_t: "Link w wiadomości e-mail",
  tp_step2_d: "Po przejeździe znajdziesz link do napiwku w e-mailu.",
  tp_step3_t: "Wybierz kwotę",
  tp_step3_d: "2, 5 lub 10 € – albo własna kwota. Płatność kartą.",
  tp_badge_free: "0 % potrąceń",
  tp_badge_safe: "Bezpiecznie kartą",
  tp_badge_free2: "Dobrowolnie",
  tp_phone_title: "Zostaw napiwek",
  tp_phone_btn: "Zostaw napiwek",
  tp_phone_to: "dla kierowcy",
  tips_card_open: "Otwarte",
  tips_card_paid: "Wypłacone",
  tips_pay_out: "Napiwki wypłacone",
  tips_pay_out_confirm: "Oznaczyć {amount} napiwków jako wypłacone dla {name}?",
  tips_history: "Historia",
  tips_history_hide: "Ukryj historię",
  tips_paid_out_on: "wypłacono dnia",
  tips_still_open: "jeszcze otwarte",
  tips_pay_out_done: "✔ {amount} oznaczono jako wypłacone.",
  tips_tab: "💝 Napiwki",
  tips_driver_month: "W tym miesiącu",
  tips_driver_total: "Razem",
  tips_driver_open: "Jeszcze otwarte",
  tips_driver_empty: "Brak otrzymanych napiwków.",
  tips_driver_passed: "✓ przekazane przez firmę",
  tips_driver_pending: "Zostanie przekazane przez firmę",
  tips_driver_hint: "Klienci mogą po przejeździe dobrowolnie zostawić napiwek. Trafia on do firmy, która przekazuje go Tobie.",
  tips_partner_title: "Napiwki",
  tips_partner_hint: "Klienci dają napiwek kierowcy. Kwota jest w Twoim portfelu – przekaż ją kierowcy i oznacz jako przekazaną.",
  tips_partner_open: "Do przekazania",
  tips_partner_passed: "Przekazane",
  tips_partner_mark: "Oznacz jako przekazane",
  tips_partner_unmark: "Cofnij oznaczenie",
  tips_partner_driver: "Kierowca",
  tips_trip_label: "Napiwek",
  tip_title: "Zostaw napiwek",
  tip_intro: "Zadowolony z przejazdu? Podziękuj napiwkiem.",
  tip_for: "dla",
  tip_goes: "Napiwek trafia w całości do firmy transportowej{company} i jest przekazywany kierowcy. Jest dobrowolny.",
  tip_choose: "Wybierz kwotę",
  tip_custom: "Inna kwota (€)",
  tip_pay: "Zapłać napiwek kartą",
  tip_thanks: "Dziękujemy! Twój napiwek w wysokości {amount} dotarł.",
  tip_given: "Za ten przejazd przekazano już {amount}.",
  tip_cancelled: "Płatność anulowana – nic nie pobrano.",
  tip_invalid: "Ten link jest nieprawidłowy.",
  tip_na: "Napiwek za ten przejazd nie jest już możliwy.",
  tip_na_expired: "Napiwek jest możliwy tylko do {days} dni po przejeździe.",
  tip_na_notdone: "Napiwek jest możliwy po zakończeniu przejazdu.",
  tip_loading: "Ładowanie …",
  tip_card_title: "Napiwek",
  tip_card_text: "Zadowolony z kierowcy? Podziękuj napiwkiem.",
  tip_card_btn: "💝 Zostaw napiwek",
  tip_card_leg_out: "za przejazd tam",
  tip_card_leg_ret: "za przejazd powrotny",
};
const uk = {
  tp_eyebrow: "Нове в GoTransfer24",
  tp_title: "Подякуйте –",
  tp_accent: "чайовими для водія",
  tp_text_free: "Задоволені поїздкою? Залиште добровільні чайові після поїздки – просто, безпечно й безготівково. Вони повністю надходять водієві, GoTransfer24 нічого не утримує.",
  tp_text_fee: "Задоволені поїздкою? Залиште добровільні чайові після поїздки – просто, безпечно й безготівково. Вони надходять транспортній компанії й передаються водієві.",
  tp_step1_t: "Насолоджуйтесь поїздкою",
  tp_step1_d: "Прибудьте спокійно – решту ми беремо на себе.",
  tp_step2_t: "Посилання в листі",
  tp_step2_d: "Після поїздки ви знайдете посилання на чайові в листі.",
  tp_step3_t: "Оберіть суму",
  tp_step3_d: "2, 5 або 10 € – або власна сума. Оплата карткою.",
  tp_badge_free: "0 % утримань",
  tp_badge_safe: "Безпечно карткою",
  tp_badge_free2: "Добровільно",
  tp_phone_title: "Залишити чайові",
  tp_phone_btn: "Залишити чайові",
  tp_phone_to: "для водія",
  tips_card_open: "Відкрито",
  tips_card_paid: "Виплачено",
  tips_pay_out: "Чайові виплачено",
  tips_pay_out_confirm: "Позначити {amount} чайових як виплачені для {name}?",
  tips_history: "Історія",
  tips_history_hide: "Сховати історію",
  tips_paid_out_on: "виплачено",
  tips_still_open: "ще відкрито",
  tips_pay_out_done: "✔ {amount} позначено як виплачені.",
  tips_tab: "💝 Чайові",
  tips_driver_month: "Цього місяця",
  tips_driver_total: "Разом",
  tips_driver_open: "Ще відкрито",
  tips_driver_empty: "Чайових ще немає.",
  tips_driver_passed: "✓ передано компанією",
  tips_driver_pending: "Компанія передасть вам",
  tips_driver_hint: "Клієнти можуть після поїздки добровільно залишити чайові. Вони надходять вашій компанії, яка передає їх вам.",
  tips_partner_title: "Чайові",
  tips_partner_hint: "Клієнти дають чайові водієві. Сума на вашому рахунку – передайте її водієві й позначте як передану.",
  tips_partner_open: "Ще передати",
  tips_partner_passed: "Передано",
  tips_partner_mark: "Позначити як передане",
  tips_partner_unmark: "Скасувати позначку",
  tips_partner_driver: "Водій",
  tips_trip_label: "Чайові",
  tip_title: "Залишити чайові",
  tip_intro: "Задоволені поїздкою? Подякуйте чайовими.",
  tip_for: "для",
  tip_goes: "Чайові повністю надходять транспортній компанії{company} і передаються вашому водієві. Це добровільно.",
  tip_choose: "Оберіть суму",
  tip_custom: "Інша сума (€)",
  tip_pay: "Сплатити чайові карткою",
  tip_thanks: "Дякуємо! Ваші чайові у розмірі {amount} отримано.",
  tip_given: "За цю поїздку ви вже залишили {amount}.",
  tip_cancelled: "Оплату скасовано – кошти не списано.",
  tip_invalid: "Це посилання недійсне.",
  tip_na: "Чайові за цю поїздку більше неможливі.",
  tip_na_expired: "Чайові можливі лише протягом {days} днів після поїздки.",
  tip_na_notdone: "Чайові можливі після завершення поїздки.",
  tip_loading: "Завантаження …",
  tip_card_title: "Чайові",
  tip_card_text: "Задоволені водієм? Подякуйте чайовими.",
  tip_card_btn: "💝 Залишити чайові",
  tip_card_leg_out: "за поїздку туди",
  tip_card_leg_ret: "за поїздку назад",
};
const all = { de, en, tr, pl, uk };
export default all;
